import React from "react";
import { formatSgDateTime } from "../../lib/format";

const SourceBadge = ({ source }) => {
  const value = source || "hero";
  const isHero = value === "hero";
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${
        isHero
          ? "bg-[#eaf4fb] text-[#3d6486]"
          : "bg-[#e8f0e8] text-[#3d6e4a]"
      }`}
    >
      {isHero ? "Hero" : "Final CTA"}
    </span>
  );
};

const AdminTable = ({ rows, totalRows, loading }) => (
  <div className="mt-5 rounded-2xl bg-white border border-[#e6eef5] shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-[#f1f6fb] text-[#3d6486]">
          <tr>
            <th className="text-left font-semibold px-5 py-3">First name</th>
            <th className="text-left font-semibold px-5 py-3">Email</th>
            <th className="text-left font-semibold px-5 py-3">Source</th>
            <th className="text-left font-semibold px-5 py-3">Joined</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#eef2f6]">
          {loading && (
            <tr>
              <td colSpan={4} className="px-5 py-10 text-center text-[#7e8a96]">
                Loading signups…
              </td>
            </tr>
          )}
          {!loading && rows.length === 0 && (
            <tr>
              <td colSpan={4} className="px-5 py-10 text-center text-[#7e8a96]">
                No signups match your filters yet.
              </td>
            </tr>
          )}
          {!loading &&
            rows.map((it) => (
              <tr
                key={it.id}
                className="hover:bg-[#f8fbfe] transition-colors"
              >
                <td className="px-5 py-3 text-[#2c3e50] font-medium">
                  {it.first_name}
                </td>
                <td className="px-5 py-3 text-[#3d6486]">{it.email}</td>
                <td className="px-5 py-3">
                  <SourceBadge source={it.source} />
                </td>
                <td className="px-5 py-3 text-[#5a6b7d]">
                  {formatSgDateTime(it.created_at)}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
    <div className="px-5 py-3 border-t border-[#eef2f6] text-xs text-[#7e8a96] flex items-center justify-between">
      <span>
        Showing {rows.length} of {totalRows} signups
      </span>
      <span>Newest first · Limit 500</span>
    </div>
  </div>
);

export default AdminTable;
